// libs
import React from 'react';

// components
import HelpTip from "../../../../../components/HelpTip";
import SystemErrorMessage from "../../../../../components/SystemErrorMessage/index";
import LoadingSpinner from "../../../../../components/LoadingSpinner/index";
import AuthService from "../../../../../services/AuthService";

const SubscriptionStatus = (props) => {
    const {
        member,
        isLoading,
        status,
        isSubscribed,
        error,
        onClickToggleStatus
    } = props;

    const message = (status) ? status.message : null;

    let wrapperClass = 'list--box list--info';
    if (status !== null && isSubscribed) {
        wrapperClass += ' list--box--success';
    }

    let helpTip = null;
    if (status !== null && status.statusHelp !== '') {
        helpTip = (<HelpTip><span>{status.statusHelp}</span></HelpTip>);
    }

    const canToggleStatus = (
        !member.isPending &&
        !member.isPendingUpdate &&
        member.isActiveRecord &&
        member.email !== '' &&
        status !== null &&
        status.canChangeStatus
    );
    let dot_digital_connection_error = false;
    if(error != null && error.search('connection') !== -1){
        dot_digital_connection_error = true;
    }

    return (
        <div className="mailchimp margin--30--bot relative">
            <h3 className="sub-title margin--10--bot">Newsletter Email Status</h3>

            {member.isPending && <div>
                <ul className={wrapperClass}>
                    <li className="loading--inline">
                        <p className="list--info__label">
                            <strong className="text--caps text--color">Status</strong> <span className="text--break">Setup in progress...</span>
                            <HelpTip>
                                <span>This is a new member and is still being set up. Their newsletter email status will be available soon.</span>
                            </HelpTip>
                        </p>
                    </li>
                </ul>
            </div>}

            {!member.isPending && <div>

                {!isLoading && error === null && message && <div className="alert alert--success alert--outline text--center margin--10--bot">{message}</div>}
                {error !== null && dot_digital_connection_error == false && <SystemErrorMessage message={error} notified={false} />}
                {error !== null && dot_digital_connection_error && AuthService.isAdmin() && <SystemErrorMessage message="DotDigital API failure. Please try again, or review the DotDigital API logs if the problem persists." notified={false} />}
                {error !== null && dot_digital_connection_error && !AuthService.isAdmin() && <SystemErrorMessage message="Sorry, newsletter email status is currently unavailable. Please try again, or contact Loyalty Support if the problem persists." notified={false} />}
                <ul className={wrapperClass}>
                    <li className="loading--inline">
                        {status !== null && <div>
                            <p className="list--info__label">
                                <strong className="text--caps text--color">Status</strong> <span className="text--break">{status.status}</span>
                                {helpTip}
                            </p>
                            {canToggleStatus && <a href="#" onClick={onClickToggleStatus} className="btn btn--small btn--color">
                                {!isSubscribed ? 'Subscribe' : 'Unsubscribe'}
                            </a>}
                        </div>}
                        {isLoading && <LoadingSpinner isVisible={true} />}

                        <img src="/img/icon-mail-cross--warning.svg" width="70" height="52" className="icon--marketing cross" />
                        <img src="/img/icon-mail-tick.svg" width="70" height="52" className="icon--marketing tick" />
                    </li>
                </ul>

            </div>}
        </div>
    );
};

export default SubscriptionStatus;
